import { jsx as _jsx } from "react/jsx-runtime";
import { NestedEditAndCreateBase } from "$components/NestedList/NestedEditAndCreateBase";
const NestedListEdit = (props) => {
    return _jsx(NestedEditAndCreateBase, { variantProps: props, variant: "edit" });
};
export { NestedListEdit };
